// Subtle prop sway — pure helper giving tall scenery (cactus, antenna, flag, dead tree, crystal,
// satellite) a gentle wind wobble so the world feels alive; squat props (rocks, craters, graves)
// stay put. Render-only: the renderer offsets the sprite by this each frame. No sim impact.

const SWAY_AMP: Record<string, number> = {
  'prop:cactus': 0.1,
  'prop:antenna': 0.16,
  'prop:flag': 0.22,
  'prop:satellite': 0.14,
  'prop:deadtree': 0.13,
  'prop:crystal': 0.07,
}

/**
 * Horizontal + vertical sway offset for a prop sprite at run time `time`, phase-separated so
 * neighbours don't move in lockstep. Returns {0,0} for non-swayable props. Pure + deterministic.
 */
export function propSway(sprite: string, time: number, phase: number): { dx: number; dy: number } {
  const amp = SWAY_AMP[sprite]
  if (!amp) return { dx: 0, dy: 0 }
  const dx = Math.sin(time * 1.6 + phase) * amp
  const dy = Math.abs(Math.sin(time * 1.6 + phase)) * amp * 0.25 // tiny lift at the sway extremes
  return { dx, dy }
}
